import { make } from 'vuex-pathify';

const state = {
    persistent: {
        demoMode: false,
        isSystemSettingsShown: false,
        hallCode: null,
        currentSkin: 'default',
        mainBackgroundImage: '/static/theme/africa/fon.svg',
        mainBackgroundSize: 'unset',
        topTitle: 'All Games',
        topBackRouteName: 'start'
    }
};

const getters = {
    hallCode: (state) => {
        return state.persistent.hallCode
    },
    isBonusEnabled: (state, getters) => {
        return !state.persistent.demoMode && getters.isMvbEnabled;
    },
    isBigSwiperIconsMode: (state, getters, rootState) => {
        if (!rootState.player) return;
        if (rootState.player.branchParameters && !!rootState.player.branchParameters['bigIcons']) {        
            switch (rootState.player.branchParameters.bigIcons.toLowerCase()) {
                case 'false':
                case 'no':
                case '0':
                case '':
                    return false;
                default:
                    return true;
            }
        } else if (rootState.player.branchParameters) {
            return true;
        }
    } 
};

export default {
    namespaced: true,
    state,
    getters,
    mutations: { ...make.mutations(state) }
};



// WEBPACK FOOTER //
// ./skins/xkiosk/data/settings.js